function getFines(apiClient, params) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/fines`;
  return apiClient.get(route, { query: params });
}

function getFinesPaymentForm(apiClient, params) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/fines/getPaymentForm`;
  return apiClient.get(route, { query: params });
}

export default {
  getFines,
  getFinesPaymentForm
};



// WEBPACK FOOTER //
// ./app/api/FinesApi.js